import React, { createContext, useContext, useState, useEffect } from 'react';
import { api } from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem('dr_sunil_admin_token') || null);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const verifyToken = async () => {
      const storedToken = localStorage.getItem('dr_sunil_admin_token');
      if (storedToken) {
        try {
          const userData = await api.getAdminMe();
          setUser(userData);
          setToken(storedToken);
        } catch (err) {
          // Token expired or invalid
          console.warn('Invalid or expired admin token. Logging out.');
          localStorage.removeItem('dr_sunil_admin_token');
          setToken(null);
          setUser(null);
        }
      }
      setLoading(false);
    };

    verifyToken();
  }, []);

  const login = async (username, password) => {
    const data = await api.login(username, password);
    if (data && data.token) {
      localStorage.setItem('dr_sunil_admin_token', data.token);
      setToken(data.token);
      try {
        const userData = await api.getAdminMe();
        setUser(userData);
      } catch {
        setUser({ username });
      }
      return data;
    }
    throw new Error('Authentication failed. No token received.');
  };

  const logout = () => {
    localStorage.removeItem('dr_sunil_admin_token');
    setToken(null);
    setUser(null);
  };

  const value = {
    token,
    user,
    isAuthenticated: Boolean(token),
    loading,
    login,
    logout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export default AuthContext;
